import { Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { WizBasePopUp, WizButton, WizCommandManager, WizEvent, WizLabel, WizPopUp, WizRoot, WizTranslationManager } from '@wizeoo/akm-component-lib';
import { CONFIRMATION_MODE, VALUE_ESCAPE } from '@wizeoo/akm-core-lib';
import { Model } from '../../../model/model';
import packageJson from 'package.json';
import { RouteEngine } from 'src/app/manager/routing/route.engine';
import { InitView } from '../init.view';
import { BaseView } from '@wizeoo/akm-common-lib';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'menu-popup',
  templateUrl: './menu.pop.html',
})
export class MenuPopUp extends WizBasePopUp {

  @ViewChild('lblUser') lblUser: WizLabel;

  // validation sur enter, sortie sur Esc
  @HostListener('window:keydown', ['$event'])
  keyEvent(event: KeyboardEvent) {
    if (event.key === VALUE_ESCAPE) {
      this.hide();
    }
  }

  public static width: string = '200px';
  public static height: string = '450px';
  
  constructor(public elementRef: ElementRef) {
    super();
  }

  /**
   * Retourne la version de l'application depuis le package.json
   */
  get applicationVersion(): string {
    return packageJson.version;
  }

  public show(): void {
    this.setUser();
  }

  public doShow(view: string): boolean {
    const currV: BaseView = Model.getInstance().navigationEngine.getCurrentView();
    //let curr: string = this.currentView;
    if(currV?.code.toUpperCase() !== view.toUpperCase()) {
      return true;
    }
    return false;
  }

  public get isVerbose(): boolean {
    return WizRoot.verboseMode;
  }

  /** déclenche une action */
  public do(action: string): void {
    switch (action) {   
      case "home":               
        Model.getInstance().navigationEngine.navigate(RouteEngine.INIT_VIEW);
           this.hide();
        break;
      case "list":               
        Model.getInstance().navigationEngine.navigate(RouteEngine.LIST_VIEW);
           this.hide();
        break; 
      case "thumb":               
        Model.getInstance().navigationEngine.navigate(RouteEngine.THUMB_VIEW);
           this.hide();
        break;  
      case "gatling":               
        Model.getInstance().navigationEngine.navigate(RouteEngine.GATLING_VIEW);
           this.hide();
        break; 
      case "log":               
        Model.getInstance().navigationEngine.navigate(RouteEngine.LOG_VIEW);
           this.hide();
        break;       
      case "add":  
          Model.getInstance().currentPrototype = null;
          Model.getInstance().navigationEngine.navigate(RouteEngine.ADD_VIEW);
          this.hide();
        break; 
      case "back":  
          window.history.back();
        break;         
    
     case 'clearCache':     
        WizCommandManager.setLock(true);
        setTimeout(() => {
          Model.getInstance().syncService.clearFD();
          Model.getInstance().syncService.clearFEI();
          Model.getInstance().syncService.clearMedia();
          Model.getInstance().compositeEngine.compositeReload();
          this.hide();
        }, (0));

        break;
      case 'refresh':  
        WizCommandManager.setLock(true);
        setTimeout(() => {
          Model.getInstance().compositeEngine.compositeReload(); 
          this.hide();
        }, (0));

        break;
      case 'clearContext':  
        Model.getInstance().userContextService.resetLocalStorage();
        this.hide();
        break;
          
      case "help":  

        break;
    }
  }


  /** jump vers une vue */
  public go(view: string): void {
    Model.getInstance().navigationEngine.navigate(view);
  }

  /** sur alimentation du user, affichage de message de bienvenue */
  private setUser(): void {
    if (Model.getInstance().connectedUser) {
      this.lblUser.wizLabel = WizTranslationManager.getInstance().translateKey('$.account.hello.$', [
        Model.getInstance().connectedUser.fullName,
      ]);
    } else {
      this.lblUser.wizLabel = ' ';
    }
  }

}
